// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__kGc2q","col":"styles_col__3dPqU","fulfillmentStatus":"styles_fulfillmentStatus__2VKqN","emailCol":"styles_emailCol__3KNOP"};